import { render, staticRenderFns } from "./currency-setting.vue?vue&type=template&id=a9044dcc&scoped=true&"
import script from "./currency-setting.vue?vue&type=script&lang=js&"
export * from "./currency-setting.vue?vue&type=script&lang=js&"
import style0 from "./currency-setting.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./currency-setting.vue?vue&type=style&index=1&id=a9044dcc&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9044dcc",
  null
  
)

export default component.exports